<template>
  <component
    :is="to ? 'router-link' : 'div'"
    :to="to"
    class="el-menu-item--custom"
    @click="$emit('click')"
  >
    <div class="tw-flex tw-items-center">
      <slot name="icon" />
      <div
        class="nav-item__label"
      >
        {{ label }}
      </div>
    </div>
  </component>
</template>

<script>
export default {
  name: 'NavItemV2',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    to: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
  },
};
</script>
